// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { GoogleLogo, ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[color:var(--paper)] flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-xl fade-in">
          <div className="eyebrow mb-6 text-center">Welcome back · or first time</div>
          <div className="border rule bg-white p-10 md:p-14 text-center">
            <h1 className="font-serif text-4xl sm:text-5xl leading-none tracking-tight">
              Sign in to Ekkol
            </h1>
            <p className="mt-6 text-[color:var(--ink-muted)] leading-relaxed">
              One tap with Google. Your decks sync across laptop and phone so you can
              rehearse on the go.
            </p>
            <button
              onClick={signIn}
              className="mt-10 w-full btn-primary justify-center"
              data-testid="google-signin-btn"
            >
              <GoogleLogo size={20} weight="bold" /> Continue with Google
              <ArrowRight size={18} weight="bold" />
            </button>

            <div className="mt-8 text-xs font-mono uppercase tracking-[0.2em] text-[color:var(--ink-faint)]">
              Private · No ads in beta · Free tier
            </div>
          </div>

          <p className="text-center text-xs text-[color:var(--ink-muted)] mt-8">
            By continuing you agree to use your mic + audio for practice sessions.
          </p>
        </div>
      </main>
    </div>
  );
}
